import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import SupplierService from 'services/supplier.ts';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';

function InfoChangeDetail(props) {
  const Config = {
    purchase: {
      title: '供应商信息变更详情',
      apiPath: '/archives/compVendorChanged/detail',
      agreeApiPath: '/archives/compVendorChanged/approve',
      returnApiPath: '/archives/compVendorChanged/overrule',
      customerNameKey: 'companyName',
      companyCodeKey: 'vendorCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Company_Changed_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Tax_Type',
          subKey: 'taxType',
          value: 'taxTypeName'
        },
        {
          mainKey: 'B02_Tax_Type',
          subKey: 'changedTaxType',
          value: 'changedTaxTypeName'
        }
      ],
      idField: 'ccXkNo',
      wfmCode: '1030'
    },
    sale: {
      title: '企业信息变更详情',
      apiPath: '/archives/compCustomerChanged/detail',
      customerNameKey: 'companyName',
      vendorNameKey: 'innerCustomerName',
      companyCodeKey: 'companyCode',
      arrEnumField: [
        {
          mainKey: 'B02_Company_Changed_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Tax_Type',
          subKey: 'taxType',
          value: 'taxTypeName'
        },
        {
          mainKey: 'B02_Tax_Type',
          subKey: 'changedTaxType',
          value: 'changedTaxTypeName'
        }
      ],
      idField: 'ccXkNo'
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true
  });

  //处理详情数据
  self.afterGetDetail = function (data) {
    //单身枚举
    data.detailList.forEach((item, i) => {
      EnumService.getValue('B02_Company_Changed_Status', item.status).then(
        value => {
          item.statusName = value;
          forceUpdate();
        }
      );
    });
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  //同意
  function agree() {
    let postbody = getPostbody(config.agreeApiPath);
    postbody = Object.assign(postbody, detail);
    SupplierService.customerChangedAgree(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //退回
  function customerChangedReturn() {
    let postbody = getPostbody(config.returnApiPath);
    SupplierService.customerChangedReturn(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey = detail.ccXkNo,
      cCode = obj[config.companyCodeKey];

    setShowLoading(true);
    CompanyService.getFileList(businessType, businessKey, '', '', cCode).then(
      res => {
        setShowLoading(false);
        if (Array.isArray(res)) {
          let arr = res.map(row => {
            return { ...row };
          });
          setFileList(arr);
        }
      }
    );
    actions.openDownloadModal();
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      ccXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="pb50">
        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>基础信息</label>
          </div>
          <ul>
            {self.isPurchase && (
              <li>
                <label className="order-detail-label">供应商</label>
                <div className="order-detail-value">
                  {detail[config.vendorNameKey]}
                </div>
              </li>
            )}
            {!self.isPurchase && (
              <li>
                <label className="order-detail-label">客户名称</label>
                <div className="order-detail-value">
                  {detail[config.vendorNameKey]}
                </div>
              </li>
            )}
            <li>
              <label className="order-detail-label">申请单号</label>
              <div className="order-detail-value">{detail.ccXkNo}</div>
            </li>
            <li>
              <label className="order-detail-label">申请日期</label>
              <div className="order-detail-value">
                {formatDate(detail.reqDate, 'YYYY-MM-DD')}
              </div>
            </li>
            <li>
              <label className="order-detail-label">申请人</label>
              <div className="order-detail-value">{detail.createName}</div>
            </li>
            <li>
              <label className="order-detail-label">状态</label>
              <div
                className={
                  'u-sign ' +
                  CommonFns.getStatusClass('d8Report', detail.status)
                }
              >
                {detail.statusName}
              </div>
            </li>

            {/* 审批流状态 仅开启后才显示 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批环节</label>
                <div className="order-detail-value">
                  <WorkflowStatus
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                  />
                </div>
              </li>
            )}
            {/* 审批流按钮 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批操作</label>
                <div className="order-detail-value">
                  <WorkflowButtons
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                    onChange={() => {
                      self.getDetail();
                    }}
                  />
                </div>
              </li>
            )}
          </ul>
        </div>

        {/*企业原用名称 */}
        {!Util.isEmpty(detail.detailList) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[1]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>企业原用名称</label>
                <i className="icon-down" onClick={() => handleBoxState(1)}></i>
              </div>
              {boxState[1] && (
                <div className="order-detail-block">
                  <ul>
                    <li>
                      <label className="order-detail-label">企业原用名称</label>
                      <div className="order-detail-value">
                        {detail.companyOriginalName}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">
                        原统一信用代码
                      </label>
                      <div className="order-detail-value">
                        {detail.creditCode}
                      </div>
                    </li>
                    {detail.detailList.map((item, index) => (
                      <li key={index}>
                        <label className="order-detail-label">
                          ERP供应商编码
                        </label>
                        <div className="order-detail-value">
                          {item.innerVendorCode} - {item.innerVendorName}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}

        {/*企业变更信息 */}
        {!Util.isEmpty(detail.detailList) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[2]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>企业变更信息</label>
                <i className="icon-down" onClick={() => handleBoxState(2)}></i>
              </div>
              {boxState[2] && (
                <div className="order-detail-block">
                  <ul>
                    <li>
                      <label className="order-detail-label">企业新名称</label>
                      <div className="order-detail-value">
                        {detail.newCompanyName}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">
                        新统一信用代码
                      </label>
                      <div className="order-detail-value">
                        {detail.changedCreditCode}
                      </div>
                    </li>
                    {self.isPurchase &&
                      detail.detailList.map((item, index) => (
                        <li key={index}>
                          <label className="order-detail-label">
                            变更后名称
                          </label>
                          <div className="order-detail-value">
                            {item.changedCompanyName}
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}

        {/*供应商档案信息 */}
        {self.isPurchase && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[3]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>供应商档案信息</label>
                <i className="icon-down" onClick={() => handleBoxState(3)}></i>
              </div>
              {boxState[3] && (
                <div className="order-detail-block">
                  <ul>
                    <li>
                      <label className="order-detail-label">交易币别</label>
                      <div className="order-detail-value">
                        {detail.currencyName}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">交易条件</label>
                      <div className="order-detail-value">
                        {detail.conditionName}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">税别</label>
                      <div className="order-detail-value">{detail.taxName}</div>
                    </li>
                    <li>
                      <label className="order-detail-label">付款条件</label>
                      <div className="order-detail-value">
                        {detail.payWayName}
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}

        {/*变更后信息 */}
        {self.isPurchase && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[4]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>变更后信息</label>
                <i className="icon-down" onClick={() => handleBoxState(4)}></i>
              </div>
              {boxState[4] && (
                <div className="order-detail-block">
                  <ul>
                    <li>
                      <label className="order-detail-label">交易币别</label>
                      <div className="order-detail-value">
                        {detail.changedCurrencyName}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">交易条件</label>
                      <div className="order-detail-value">
                        {detail.changedConditionName}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">税别</label>
                      <div className="order-detail-value">
                        {detail.changedTaxName}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">付款条件</label>
                      <div className="order-detail-value">
                        {detail.changedPayWayName}
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}

        {/*企业原用信息 */}
        <div className="order-detail-box">
          <div className="order-detail-block">
            <div
              className={
                !boxState[5]
                  ? 'order-detail-title m-more'
                  : 'order-detail-title m-more m-more-open'
              }
            >
              <label>企业原用信息</label>
              <i className="icon-down" onClick={() => handleBoxState(5)}></i>
            </div>
            {boxState[5] && (
              <div className="order-detail-block">
                <ul>
                  <li>
                    <label className="order-detail-label">开户行</label>
                    <div className="order-detail-value">
                      {detail.openAccountBankName}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">开户名称</label>
                    <div className="order-detail-value">
                      {detail.openAccountName}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">银行账号</label>
                    <div className="order-detail-value">
                      {detail.bankCardNo}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">税务类型</label>
                    <div className="order-detail-value">
                      {detail.taxTypeName}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">企业地址</label>
                    <div className="order-detail-value">{detail.address}</div>
                  </li>
                  <li>
                    <label className="order-detail-label">银行联行号</label>
                    <div className="order-detail-value">
                      {detail.unionBankNo}
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        {/*企业变更信息 */}
        <div className="order-detail-box">
          <div className="order-detail-block">
            <div
              className={
                !boxState[6]
                  ? 'order-detail-title m-more'
                  : 'order-detail-title m-more m-more-open'
              }
            >
              <label>企业变更信息</label>
              <i className="icon-down" onClick={() => handleBoxState(6)}></i>
            </div>
            {boxState[6] && (
              <div className="order-detail-block">
                <ul>
                  <li>
                    <label className="order-detail-label">开户行</label>
                    <div className="order-detail-value">
                      {detail.changedOpenAccountBankName}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">开户名称</label>
                    <div className="order-detail-value">
                      {detail.changedOpenAccountName}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">银行账号</label>
                    <div className="order-detail-value">
                      {detail.changedBankCardNo}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">税务类型</label>
                    <div className="order-detail-value">
                      {detail.changedTaxTypeName}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">企业地址</label>
                    <div className="order-detail-value">
                      {detail.changedAddress}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">银行联行号</label>
                    <div className="order-detail-value">
                      {detail.changedUnionBankNo}
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        {/*附件 */}
        <div className="order-detail-box">
          <div className="order-detail-block">
            <div className="order-detail-title">
              <label>附件</label>
            </div>
            <div className="order-detail-block">
              <ul>
                <li>
                  <label className="order-detail-label">
                    {!Util.isEmpty(detail.fileMd5s) && (
                      <span
                        className="attachment"
                        onClick={() => showFileList(89, detail)}
                      >
                        {detail.fileMd5s?.length}个附件
                        <i className="icon-attachment"></i>
                      </span>
                    )}
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {/* {User.checkAuth('10052002') &&
            [1].includes(detail.status) &&
            workflow.data &&
            workflow.data['vInfoChanged_audit'].complete && (
              <Button
                type="default"
                onClick={() => {
                  agree();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                同意
              </Button>
            )} */}

          {/* {User.checkAuth('10052002') &&
            [1].includes(detail.status) &&
            workflow.data &&
            workflow.data['vInfoChanged_audit'].complete && (
              <Button
                type="default"
                onClick={() => {
                  customerChangedReturn();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                退回
              </Button>
            )} */}
        </div>
      )}

      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
    </div>
  );
}

InfoChangeDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoChangeDetail);
